import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCirclePlusRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 5.6a10.4 10.4 0 1 1 0 20.8 10.4 10.4 0 0 1 0-20.8m0 23.2a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6m-1.2-8.4a1.2 1.2 0 1 0 2.4 0v-3.2h3.2a1.2 1.2 0 1 0 0-2.4h-3.2v-3.2a1.2 1.2 0 1 0-2.4 0v3.2h-3.2a1.2 1.2 0 1 0 0 2.4h3.2z" })
});
export default SvgCirclePlusRegularIcon;
